import { REQUEST_SITE_INFO, RECEIVE_SITE_INFO } from '../constants/action-types'
import { handleResponse } from '../utils/response-utils'
import { getSiteInfoUrl } from '../utils/url-utils'

export const requestSiteInfo = () => ({
  type: REQUEST_SITE_INFO
})

export const receiveSiteInfo = (response, error) => ({
  type: RECEIVE_SITE_INFO,
  payload: response,
  error
})

export const fetchSiteInfo = queryParams => dispatch => {
  dispatch(requestSiteInfo())
  return fetch(`${getSiteInfoUrl()}?${queryParams}`, {
    method: 'GET',
    credentials: 'same-origin'
  })
    .then(res => handleResponse(res))
    .then(data => dispatch(receiveSiteInfo(data, false)))
    .catch(error => dispatch(receiveSiteInfo(error, true)))
}



// WEBPACK FOOTER //
// ./src/actions/site-info-actions.js